import {UserPersona} from "@khan/guide-types";
import type {UserAttributes} from "@khan/shared-core";

export const getDefaultPersonaForUser = (
    userAttributes: UserAttributes | null | undefined,
): UserPersona => {
    if (!userAttributes) {
        return UserPersona.Student;
    }
    if (userAttributes.hasAccessToAIGuideDistrictAdmin) {
        return UserPersona.DistrictAdmin;
    }
    return userAttributes.hasAccessToAIGuideTeacher
        ? UserPersona.Teacher
        : userAttributes.hasAccessToAIGuideParent
          ? UserPersona.Parent
          : UserPersona.Student;
};
